import NotificationService from '@/services/api/NotificationService';

export default {
  state: {
    notifications: [],
  },

  mutations: {
    updateNotifications(state, updatedNotifications) {
      state.notifications = updatedNotifications;
    },
  },

  actions: {
    fetchNotifications({ commit }) {
      return new Promise((resolve, reject) => {
        NotificationService.fetchAll()
          .then(notifications => {
            commit('updateNotifications', notifications);
            resolve(notifications);
          })
          .catch(error => reject(error));
      });
    },

    readNotification({ dispatch }, id) {
      return new Promise((resolve, reject) => {
        NotificationService.read(id)
          .then(data => {
            dispatch('fetchNotifications');
            resolve(data);
          })
          .catch(error => reject(error));
      });
    },
  },

  getters: {
    notifications(state) {
      return state.notifications;
    },
  },
};
